const getOperatorViolationsResponse = (response) => {
  const result = {
    ...response?.data,
    dataSource: response?.data?.violationsReport?.map((item) => {
      return {
        ...item,
        notes: item?.notes ?? '-',
      };
    }),
  };

  return result;
};

export default getOperatorViolationsResponse;
